<template>
<div>
  <autocomplete></autocomplete>
  <slider></slider>
  <knob></knob>
  <uswitch></uswitch>
  <tags></tags>
  <color-picker></color-picker>
  <date-time-picker></date-time-picker>
  <drag-drop></drag-drop>
  <floating-label></floating-label>
  <input-multiplier></input-multiplier>
  <masked-input></masked-input>
  <strenght-meter></strenght-meter>
  <long-press-button></long-press-button>
  <star-rating></star-rating>
  <markdown-editor></markdown-editor>
  <text-editor></text-editor>
  <captcha></captcha>
</div>
</template>

<script>
import Autocomplete from './Autocomplete.vue';
import Captcha from './Captcha.vue';
import ColorPicker from './ColorPicker.vue';
import DateTimePicker from './DateTimePicker.vue';
import DragDrop from './DragDrop.vue';
import FloatingLabel from './FloatingLabel.vue';
import InputMultiplier from './InputMultiplier.vue';
import Knob from './Knob.vue';
import LongPressButton from './LongPressButton.vue';
import MarkdownEditor from './MarkdownEditor.vue';
import MaskedInput from './MaskedInput.vue';
import Slider from './Slider.vue';
import StarRating from './StarRating.vue';
import StrenghtMeter from './StrenghtMeter.vue';
import Switch from './Switch.vue';
import Tags from './Tags.vue';
import TextEditor from './TextEditor.vue';

export default {
  components: {
    Autocomplete,
    Captcha,
    ColorPicker,
    DateTimePicker,
    DragDrop,
    FloatingLabel,
    InputMultiplier,
    Knob,
    LongPressButton,
    MarkdownEditor,
    MaskedInput,
    Slider,
    StarRating,
    StrenghtMeter,
    uswitch: Switch,
    Tags,
    TextEditor,
  },
};
</script>
